import { useStore } from 'effector-react';
import { $user, $userLoading, $userInitialLoading, $loginError } from './user';

export const useUser = () => ({
  user: useStore($user),
  loading: useStore($userLoading),
  initialLoading: useStore($userInitialLoading),
  loginError: useStore($loginError),
});
